import React, { useState, useEffect, useRef } from 'react';

import AudioControls from './AudioControls';
import { ReactComponent as IconPrabhupad } from '../../assets/images/iconPrabhupad.svg';
import ReactPlayer from 'react-player';

// import Backdrop from './Backdrop';
import moment from 'moment';
import {
  // downloadMp3,
  // downloadFile,
  downloadResource,
  formatSecondsAsTime,
  checkMobile,
  secondsToTime,
} from '../../utils/helpers';
import { IFile } from '../../services/api/requests/getAudioList';
import './styles.css';
import { playAudioTrack } from '../../store/entities/actions';
import { useDispatch } from 'react-redux';
import Volume from '../Volume';
// import useDeviceDetect from '../../utils/deviceDetector';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { deviceMaxWidth } from '../../constants';

export default function AudioPlayer({ tracks }: any) {
  // State
  const [trackIndex, setTrackIndex] = useState(0);
  const [trackProgress, setTrackProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volumeState, setVolume] = useState(0.5);
  const [showTimer, setShowTimer] = useState(false);
  const [duration, setDuration] = useState<any>(0);
  const playerRef = useRef<ReactPlayer | null>(null);

  const dispatch = useDispatch();
  const width = window.innerWidth;
  let timePosition = 0;

  useEffect(() => {
    if (tracks.length) {
      tracks.find((track: IFile, id: number) => {
        if (track.isPlaying) {
          setTrackIndex(id);
          setIsPlaying(true);
        }
        return null;
      });
    }
  }, [tracks, trackIndex]);

  const title = tracks[trackIndex]?.audioTitle || '-';
  const date = tracks[trackIndex]?.date || moment();
  const place = tracks[trackIndex]?.place || '';
  const f = tracks[trackIndex]?.f || '';
  const audioSrc = `${process.env.REACT_APP_FILES_URL}${f}`;
  const audioDate = date ? moment(date).format('D MMMM, YYYY') : '-';
  const audioLocation = place?.combine_name || '-';
  const timerDuration = formatSecondsAsTime(Math.floor(duration));
  const timer = secondsToTime(playerRef.current?.getCurrentTime() || 0);

  const percentage = (trackProgress / duration) * 100;
  const currentPercentage = duration ? `${percentage}%` : '0%';

  timePosition = (width * percentage) / 100;
  const trackStyling = `
    -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(${currentPercentage}, #FAD1B4), color-stop(${currentPercentage}, #FAD1B0))
  `;

  const handleSeekMouseUp = (value: any) => {
    setTrackProgress(value);
    playerRef.current?.seekTo(parseFloat(value));
  };

  const onSeekStart = () => {
    setShowTimer(true);
  };

  const onSeekEnd = () => {
    setShowTimer(false);
  };

  const toPrevTrack = () => {
    if (trackIndex - 1 < 0) {
      const id = tracks.length - 1;
      const prevTrack = tracks[id];
      dispatch(playAudioTrack(prevTrack.id));
      // setTrackIndex(tracks.length - 1);
    } else {
      dispatch(playAudioTrack(tracks[trackIndex - 1].id));
      // setTrackIndex(trackIndex - 1);
    }
  };

  const toNextTrack = () => {
    if (trackIndex < tracks.length - 1) {
      const id = trackIndex + 1;
      const nextTrack = tracks[id];
      dispatch(playAudioTrack(nextTrack.id));
    } else {
      // setTrackIndex(0);
      // dispatch(playAudioTrack(tracks[0].id));
    }
  };

  const download = () => {
    downloadResource(audioSrc, `Архив_Прабхупады_${title}.mp3`);
  };

  const forward = () => {
    const value = trackProgress + 10;
    setTrackProgress(value);
    playerRef.current?.seekTo(value);
  };

  const backward = () => {
    const value = trackProgress - 10;
    setTrackProgress(value);
    playerRef.current?.seekTo(value);
  };

  const handleDuration = (duration: any) => {
    setDuration(duration);
  };

  const styles = useStyles({ timePosition, percentage, showTimer });

  return (
    <div key="audio-player" className="audio-player">
      {/*<span className="timer" />*/}
      {/*<output className={styles.timer}>{`${timer} / ${*/}
      {/*  timerDuration || ''*/}
      {/*}`}</output>*/}
      <span className={styles.timer}>{`${timer} / ${
        timerDuration || ''
      }`}</span>
      <input
        type="range"
        value={trackProgress}
        step="1"
        min="0"
        max={duration}
        className="progress"
        onChange={(e) => handleSeekMouseUp(e.target.value)}
        onMouseDown={onSeekStart}
        onMouseUp={onSeekEnd}
        style={{ background: trackStyling }}
      />
      <ReactPlayer
        ref={playerRef}
        style={{ display: 'none' }}
        onProgress={(state) => {
          setTrackProgress(state.playedSeconds);
        }}
        controls={true} // visibility
        playing={isPlaying}
        volume={volumeState}
        url={audioSrc}
        onDuration={handleDuration}
      />
      {checkMobile() ? (
        <div className={styles.audioPlayerContent}>
          <div className="timing">{`${timer} / ${timerDuration || ''}`}</div>
          <div className="track">
            <div className="track-info">
              <div className="title">{title}</div>
              {/*<div className="place">{`${audioDate}, ${audioLocation}`}</div>*/}
            </div>
          </div>
          <AudioControls
            isPlaying={isPlaying}
            onPrevClick={toPrevTrack}
            onNextClick={toNextTrack}
            forwardClick={forward}
            backwardClick={backward}
            onPlayClick={() => setIsPlaying(!isPlaying)}
            onPlayPauseClick={setIsPlaying}
          />
          {/*<div className="right-controls">*/}
          {/*  <div className="download" onClick={download}>*/}
          {/*    Скачать*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      ) : (
        <div className={styles.audioPlayerContent}>
          <AudioControls
            isPlaying={isPlaying}
            onPrevClick={toPrevTrack}
            onNextClick={toNextTrack}
            forwardClick={forward}
            backwardClick={backward}
            onPlayClick={() => setIsPlaying(!isPlaying)}
            onPlayPauseClick={setIsPlaying}
          />
          <div className="timing">{`${timer} / ${timerDuration || ''}`}</div>
          <div className="track">
            <div className="logo">
              <IconPrabhupad />
            </div>
            <div className="track-info">
              {/*<img*/}
              {/*  className="artwork"*/}
              {/*  src={image}*/}
              {/*  alt={`track artwork for ${title} by ${artist}`}*/}
              {/*/>*/}
              <div className="title">{title}</div>
              <div className="place">{`${audioDate}, ${audioLocation}`}</div>
              {/*<h3 className="artist">{`${*/}
              {/*  // @ts-ignore*/}
              {/*  (trackProgress * 60)/100}/${trackDuration}`}*/}
              {/*</h3>*/}
              {/*<h3 className="artist">{`${format(duration * trackProgress, 'mm:ss')}/${trackDuration}`}</h3>*/}
              {/*<h3 className="artist">{date}</h3>*/}
            </div>
          </div>
          <div className="right-controls">
            <Volume setVolume={setVolume} volume={volumeState} />
            <div className="download" onClick={download}>
              Скачать
            </div>
          </div>
        </div>
      )}

      {/*<Backdrop*/}
      {/*  trackIndex={trackIndex}*/}
      {/*  activeColor={color}*/}
      {/*  isPlaying={isPlaying}*/}
      {/*/>*/}
    </div>
  );
}

// TODO: move styles from css to the hook
const useStyles = makeStyles<
  Theme,
  { timePosition: number; percentage: number; showTimer: boolean }
>((theme) => ({
  audioPlayerContent: {
    height: 115,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',

    [deviceMaxWidth.size500]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'column',
    },
  },
  timer: {
    display: ({ showTimer }) => (showTimer ? 'block' : 'none'),
    position: 'absolute',
    top: -34,
    fontSize: 16,
    color: '#603004',
    left: ({ timePosition, percentage }) => {
      if (percentage > 80) {
        return timePosition - 90;
      }
      if (percentage < 20) {
        return timePosition + 5;
      }
      return timePosition;
    },
  },
}));
